<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header v-if="resource.detail">
                        <figure><i class="icon" v-bind:class="{'icon-icon_email':resource.detail.support == 'email','icon-icon_sms':resource.detail.support == 'sms'}"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Statistiques
                            </span>
                            <h1>{{ resource.detail.name.fr }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Clics" v-if="stats">

                                <line-chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="resource.stats && stats.labels.length > 1"></line-chart>
                                <bar-chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="resource.stats && stats.labels.length == 1"></bar-chart>

                                <h2>Liste des URLs</h2>

                                <div class="datagrid campiagn-publication-links">
                                    <div class="datagrid-header">
                                        <div>
                                            <div></div>
                                            <div><span>Pages de destination</span></div>
                                            <div class="center"><span>Clics</span></div>
                                            <div class="center"><span>Utilisateurs</span></div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <div class="datagrid-body">
                                        <div v-for="item in resource.links">
                                            <div></div>
                                            <div><strong>{{ item.url }}</strong></div>
                                            <div class="center">{{ item.count }}</div>
                                            <div class="center">{{ item.count_unique }}</div>
                                            <div></div>
                                        </div>
                                    </div>
                                </div>


                            </tab>
                            <tab name="Détail des envois" v-if="resource.stats && resource.stats.total">

                                <div class="widget-content-datas">
                                    <div>
                                        <div class="data-label">
                                            <span>Total envois</span> {{ resource.stats.total.sent }}
                                            <i class="icon icon-icon_sms"></i>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="data-label">
                                            <span>Total des ouvertures</span> {{ resource.stats.total.opened }}
                                            <i class="icon icon-icon_email"></i>
                                        </div>
                                    </div>
                                </div>

                                <bar-chart :dataset="sent.dataset" :labels="sent.labels" :options="options2" v-if="resource.stats && sent.labels.length"></bar-chart>

                                <h2>Audience</h2>

                                <div class="datagrid campiagn-publication-links" v-if="resource.stats && resource.stats.sent">
                                    <div class="datagrid-header">
                                        <div>
                                            <div></div>
                                            <div></div>
                                            <div><span>Prénom</span></div>
                                            <div><span>Nom</span></div>
                                            <div><span>Destination</span></div>
                                            <div class="center"><span>Envoyé le</span></div>
                                            <div class="center"><span>Vu le</span></div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <div class="datagrid-body">
                                        <div v-for="item in resource.stats.sent.listing">
                                            <div></div>
                                            <div class="picture" :title="item.status">
                                                <i class="icon icon-order-success status-completed" v-if="item.terminated_at"></i>
                                                <i class="icon icon-order-pending status-pending" v-if="!item.terminated_at"></i>
                                            </div>
                                            <div><strong>{{ item.firstname }}</strong></div>
                                            <div><strong>{{ item.lastname }}</strong></div>
                                            <div>{{ item.to }}</div>
                                            <div class="center"><datetime v-model="item.terminated_at"></datetime></div>
                                            <div class="center"><datetime v-model="item.opened_at"></datetime></div>
                                            <div></div>
                                        </div>
                                    </div>
                                </div>

                            </tab>
                        </tabs>

                    </main>

                    <footer>
                    </footer>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import CampaignService from './CampaignPublicationService.js';
    import Edit from '../../../layouts/Edit.vue';
    import Line from '../../../components/chart/Line.vue'
    import Bar from '../../../components/chart/Bar.vue'

    export default {
        extends: Edit,
        components: {
            'line-chart' : Line,
            'bar-chart' : Bar
        },
        data () {
            return {
                stats: {
                    dataset: null,
                    labels: null
                },
                sent: {
                    dataset: null,
                    labels: null
                },
                count: null,
                total: null,
                options: {
                    layout: {
                        padding: {
                            left: 20,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    scales: {
                        xAxes: [ {
                            categoryPercentage: 0.9,
                            barPercentage: 0.9,
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: false,
                                display: false,
                                color: "#cccccc"
                            }
                        }],
                        yAxes: [ {
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: true,
                                display: true,
                                color: "#cccccc",
                                borderDashOffset: 1,
                                borderDash: [2,2]
                            },
                            ticks: {
                                stepSize: 1,
                                suggestedMax: 0
                            }
                        }]
                    }
                }
            }
        },
        mounted: function(){

        },
        methods:{
            resourceLoaded: function(){

                this.options.scales.yAxes[0].ticks.suggestedMax = this.resource.stats.clicks.max + 1
                this.options.scales.yAxes[0].ticks.suggestedMin = 0

                this.stats.dataset = this.resource.stats.clicks.dataset
                this.stats.labels = this.resource.stats.clicks.labels

                this.options2 = this.copy( this.options )

                this.options2.scales.yAxes[0].ticks.suggestedMax = this.resource.stats.sent.max
                this.options2.scales.yAxes[0].ticks.stepSize = Math.round(this.resource.stats.sent.max / 10)
                this.options2.scales.yAxes[0].ticks.suggestedMin = 0

                this.sent.dataset = this.resource.stats.sent.dataset
                this.sent.labels = this.resource.stats.sent.labels

                this.initialize()
            },
            beforeUpdate: function(Resource){

                return true;
            },
            getResource: function(){
                return CampaignService
            },
            back: function(){
                self = this
                if( this.className == "" ){
                    self.$router.back();
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/campaign/campaign/Detail.vue